import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetWorkflowRuleFieldInputOptionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetWorkflowRuleFieldInputOptionsQueryResult = { __typename?: 'Query' } & {
  workflowRuleFieldInputOptions: Array<
    { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
  >;
};

export const GetWorkflowRuleFieldInputOptionsDocument = /*#__PURE__*/ gql`
  query getWorkflowRuleFieldInputOptions {
    workflowRuleFieldInputOptions {
      component
      label
      name
    }
  }
`;

/**
 * __useGetWorkflowRuleFieldInputOptionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowRuleFieldInputOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowRuleFieldInputOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowRuleFieldInputOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowRuleFieldInputOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowRuleFieldInputOptionsQueryResult,
    GetWorkflowRuleFieldInputOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetWorkflowRuleFieldInputOptionsQueryResult, GetWorkflowRuleFieldInputOptionsQueryVariables>(
    GetWorkflowRuleFieldInputOptionsDocument,
    options
  );
}
export function useGetWorkflowRuleFieldInputOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowRuleFieldInputOptionsQueryResult,
    GetWorkflowRuleFieldInputOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetWorkflowRuleFieldInputOptionsQueryResult, GetWorkflowRuleFieldInputOptionsQueryVariables>(
    GetWorkflowRuleFieldInputOptionsDocument,
    options
  );
}
export type GetWorkflowRuleFieldInputOptionsQueryHookResult = ReturnType<typeof useGetWorkflowRuleFieldInputOptionsQuery>;
export type GetWorkflowRuleFieldInputOptionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowRuleFieldInputOptionsLazyQuery>;
